// import {
//   APIClient,
//   setTokens,
//   clearAuth,
//   updateUserData,
// } from "../../../helpers/api_helper";
// import {
//   loginSuccess,
//   logoutUserSuccess,
//   apiError,
//   reset_login_flag,
// } from "./reducer";

// const api = new APIClient();

// export const loginUser = (user: any, history: any) => async (dispatch: any) => {
//   try {
//     dispatch({ type: "login/setLoading", payload: true });
//     console.log("Login attempt with data:", user);
    
//     // Send login request
//     const response = await api.post("/auth/login", {
//       login: user.login || user.username, 
//       password: user.password,
//     }) 

//     console.log("Login response:", response.data);

//     if (response && response.data.user) {
//       // Store tokens if provided
//       if (response.data.tokens?.accessToken) {
//         setTokens(response.data.tokens.accessToken, response.data.tokens.refreshToken);
//       } else if (response.data.accessToken) {
//         // Backward compatibility
//         setTokens(response.data.accessToken, response.data.refreshToken);
//       }

//       // Update user data in storage
//       updateUserData(response.data.user);

//       dispatch(
//         loginSuccess({
//           user: response.data.user,
//           accessToken: response.data.tokens?.accessToken || response.data.accessToken,
//           refreshToken: response.data.tokens?.refreshToken || response.data.refreshToken,
//         }),
//       );

//       // Navigate to dashboard
//       history("/dashboard");
      
//       return { success: true, data: response.data };
//     } else {
//       throw new Error(response?.message || 'Login failed - Invalid response from server');
//     }
//   } catch (error: any) {
//     console.error("Login error:", error);
    
//     let errorMessage = 'Login failed';
    
//     if (error.response?.data?.message) {
//       errorMessage = error.response.data.message;
//     } else if (error.message) {
//       errorMessage = error.message;
//     } else if (typeof error === 'string') {
//       errorMessage = error;
//     }
    
//     dispatch(apiError(errorMessage));
//     throw new Error(errorMessage);
//   } finally {
//     dispatch({ type: 'login/setLoading', payload: false });
//   }
// };

// export const logoutUser = () => async (dispatch: any) => {
//   try {
//     // Call logout endpoint on backend if needed
//     const token = localStorage.getItem("accessToken");
//     if (token) {
//       await api.post("/auth/logout", {});
//     }
//   } catch (error) {
//     console.error("Logout error:", error);
//   } finally {
//     // Clear all auth data
//     clearAuth();
//     dispatch(logoutUserSuccess(true));
//   }
// };

// export const refreshTokenAction = () => async (dispatch: any) => {
//   try {
//     const refreshToken = localStorage.getItem("refreshToken");

//     if (!refreshToken) {
//       throw new Error("No refresh token available");
//     }

//     const response = await api.post("/auth/refresh-token", {
//       refreshToken,
//     });

//     if (response.data.accessToken) {
//       setTokens(response.data.accessToken, response.data.refreshToken);
//       return response.data.accessToken;
//     }
//   } catch (error) {
//     // Refresh failed, logout user
//     dispatch(logoutUser());
//     return null;
//   }
// };

// // For other pages, create similar thunks using the APIClient
// export const fetchUserProfile = () => async (dispatch: any) => {
//   try {
//     dispatch({ type: "profile/setLoading", payload: true });

//     const response = await api.get("/user/profile");

//     if (response) {
//       dispatch({ type: "profile/setData", payload: response });
//     }

//     return response;
//   } catch (error: any) {
//     dispatch(apiError(error.message || "Failed to fetch profile"));
//     throw error;
//   } finally {
//     dispatch({ type: "profile/setLoading", payload: false });
//   }
// };


// export const resetLoginFlag = () => async (dispatch: any) => {
//   try {
//     dispatch(reset_login_flag());
//   } catch (error) {
//     dispatch(apiError(error));
//   }
// };


// src/store/login/thunk.ts
import {
  APIClient,
  setTokens,
  clearAuth,
  updateUserData,
} from "../../../helpers/api_helper";
import {
  loginSuccess,
  logoutUserSuccess,
  apiError,
  reset_login_flag,
} from "./reducer";

const api = new APIClient();

export const loginUser = (user: any, history: any) => async (dispatch: any) => {
  try {
    dispatch({ type: "login/setLoading", payload: true });
    console.log("Login attempt with data:", user);
    
    // Send login request
    const response = await api.post("/auth/login", {
      login: user.login || user.username, 
      password: user.password,
    });

    console.log("Login response:", response);

    // The response from api.post already returns the data (due to interceptor)
    // So response is the actual response data, not the axios response object
    const responseData = response;

    // Check if login was successful
    if (responseData && responseData.success === true) {
      // Extract user and tokens from response
      const userData = responseData.user;
      const accessToken = responseData.accessToken;
      const refreshToken = responseData.refreshToken;

      if (!userData) {
        throw new Error("User data not found in response");
      }

      // Store tokens if provided
      if (accessToken) {
        setTokens(accessToken, refreshToken);
      }

      // Update user data in storage
      updateUserData(userData);

      dispatch(
        loginSuccess({
          user: userData,
          accessToken: accessToken,
          refreshToken: refreshToken,
        })
      );

      // Navigate to dashboard
      history("/dashboard");
      
      return { success: true, data: userData };
    } else {
      // Handle unsuccessful login
      const errorMessage = responseData?.message || 'Login failed';
      throw new Error(errorMessage);
    }
  } catch (error: any) {
    console.error("Login error:", error);
    
    let errorMessage = 'Login failed';
    
    if (error.response?.data?.message) {
      errorMessage = error.response.data.message;
    } else if (error.message) {
      errorMessage = error.message;
    } else if (typeof error === 'string') {
      errorMessage = error;
    }
    
    dispatch(apiError(errorMessage));
    throw new Error(errorMessage);
  } finally {
    dispatch({ type: 'login/setLoading', payload: false });
  }
};

export const logoutUser = () => async (dispatch: any) => {
  try {
    // Call logout endpoint on backend if needed
    const token = localStorage.getItem("accessToken");
    if (token) {
      await api.post("/auth/logout", {});
    }
  } catch (error) {
    console.error("Logout error:", error);
  } finally {
    // Clear all auth data
    clearAuth();
    dispatch(logoutUserSuccess(true));
  }
};

export const refreshTokenAction = () => async (dispatch: any) => {
  try {
    const refreshToken = localStorage.getItem("refreshToken");

    if (!refreshToken) {
      throw new Error("No refresh token available");
    }

    const response = await api.post("/auth/refresh-token", {
      refreshToken,
    });

    console.log("Refresh token response:", response);

    // Handle different response structures
    let accessToken = null;
    let newRefreshToken = null;

    // Check if response has tokens directly
    if (response?.accessToken) {
      accessToken = response.accessToken;
      newRefreshToken = response.refreshToken;
    } 
    // Check if response has data wrapper
    else if (response?.data?.accessToken) {
      accessToken = response.data.accessToken;
      newRefreshToken = response.data.refreshToken;
    }
    // Check if response is wrapped in data.data
    else if (response?.data?.data?.accessToken) {
      accessToken = response.data.data.accessToken;
      newRefreshToken = response.data.data.refreshToken;
    }

    if (accessToken) {
      setTokens(accessToken, newRefreshToken || refreshToken);
      
      // Update Redux store
      dispatch({
        type: "login/updateTokens",
        payload: {
          accessToken: accessToken,
          refreshToken: newRefreshToken || refreshToken,
        },
      });

      return accessToken;
    } else {
      throw new Error("No access token received");
    }
  } catch (error) {
    console.error("Refresh token error:", error);
    // Refresh failed, logout user
    dispatch(logoutUser());
    return null;
  }
};

// For other pages, create similar thunks using the APIClient
export const fetchUserProfile = () => async (dispatch: any) => {
  try {
    dispatch({ type: "profile/setLoading", payload: true });

    const response = await api.get("/user/profile");

    if (response) {
      dispatch({ type: "profile/setData", payload: response });
    }

    return response;
  } catch (error: any) {
    dispatch(apiError(error.message || "Failed to fetch profile"));
    throw error;
  } finally {
    dispatch({ type: "profile/setLoading", payload: false });
  }
};

export const resetLoginFlag = () => async (dispatch: any) => {
  try {
    dispatch(reset_login_flag());
  } catch (error) {
    dispatch(apiError(error));
  }
};